import type { Tone } from '../../components/StatusBadge';
import type { SystemState } from './health';

export const systemStateView: Record<SystemState, { tone: Tone; label: string }> = {
  checking: { tone: 'neutral', label: 'Verificando' },
  operational: { tone: 'ok', label: 'Operacional' },
  degraded: { tone: 'warn', label: 'Degradado' },
  unreachable: { tone: 'crit', label: 'Sem conexão' },
};

/** Anchor of the system section on the platform's "Painel" (0.67.0). */
export const systemSectionId = 'sistema';
/** Where the system's details live (super administrators): the former /system. */
export const systemDetailsPath = `/overview#${systemSectionId}`;
